"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.Spec = exports.NAMESPACE = void 0;
const platform_1 = require("@effect/platform");
const effect_1 = require("effect");
const openapi_1 = require("../../../../openapi");
const Pubsub = __importStar(require("./schema"));
exports.NAMESPACE = 'Culligan.Api.V2.Spec.Legacy.Pubsub.Spec';
/*
 * `routes/v2/pubsub/device/router.js`: `QueryStringRouteGuard` on the
 * server-to-server `key` (`API_STS_TOKEN`, with the previous token accepted
 * during a rotation); controller on protocol v1.
 */
/** 422 `{ message: INVALID_REQUEST }` without `inputValidation`: the envelope or the command body is invalid. */
const InvalidEnvelope = effect_1.Schema.Struct({
    success: effect_1.Schema.Literal(false),
    error: effect_1.Schema.Struct({ message: effect_1.Schema.Literal('INVALID_REQUEST') }),
}).annotations({
    identifier: `${exports.NAMESPACE}.InvalidEnvelope`,
    title: 'Invalid Envelope',
    description: 'Neither `deviceId` nor `serialNumber` is given, or the command body is incomplete',
    [platform_1.HttpApiSchema.AnnotationStatus]: 422,
});
const dispatch = platform_1.HttpApiEndpoint.post('dispatchDeviceCommand') `/device/command`
    .setPayload(Pubsub.Envelope)
    .addSuccess(openapi_1.Response.EmptyData.annotations({ description: 'The command was processed' }))
    .addError(InvalidEnvelope)
    .annotate(platform_1.OpenApi.Title, 'Dispatch Device Command')
    .annotate(platform_1.OpenApi.Description, 'Entry point of the Pub/Sub push subscription for device commands. Routes the command to the consumables, vending configuration or ping handler by name prefix. ' +
    'Always answers 200 once the envelope is valid, even when the handler fails or the command is unsupported; failures are logged only.')
    // The query-string guard answers 401 only (through the middleware); no role check, so no 403.
    .middleware(openapi_1.Security.V1ServerToServer)
    .pipe(openapi_1.Error.withV1PublicErrors);
exports.Spec = platform_1.HttpApiGroup.make('v2.pubsub.device')
    .add(dispatch)
    .prefix('/pubsub')
    .annotate(platform_1.OpenApi.Title, 'Pub/Sub Device')
    .annotate(platform_1.OpenApi.Description, 'Server-to-server entry points fed by the Pub/Sub push subscriptions. ' +
    'Not published to any audience document: the legacy documents never listed this route and its `key` credential is a deployment secret.');
//# sourceMappingURL=spec.js.map